<template>
    <div>
        <van-nav-bar :title="userPaperDetail.paper_period.title" left-arrow @click-left="back" />

        <middle-loading :loading="loading" v-if="loading" />

        <template v-else>
            <user-paper-result>
                <template #title>答题结果</template>
                <template #correct>{{ userPaperDetail.correct_count }}</template>
                <template #wrong>
                    {{ userPaperDetail.paper_period.question_numbers - userPaperDetail.correct_count }}
                </template>
                <template #time>{{ secondsToHms(userPaperDetail.duration_seconds) }}</template>
            </user-paper-result>

            <div class="paper-card">
                <div class="card-title">
                    <span class="title">答题卡</span>
                    <div>
                        <span class="current">答对</span>
                        <span class="wrong">答错</span>
                    </div>
                </div>
                <div class="card-content">
                    <div
                        class="item"
                        v-for="(item, index) in questionList"
                        :key="item.id"
                        @click="showPopup(item.id, index + 1)"
                        :class="[item.is_correct ? 'green' : 'red']"
                    >
                        {{ (index + 1).toString().padStart(2, '0') }}
                    </div>
                </div>
            </div>

            <div class="btn">
                <van-button
                    round
                    type="info"
                    @click="$router.push({ name: 'PaperPeriodRank', query: { id: userPaperDetail.paper_period.id } })"
                >
                    查看排行
                </van-button>
            </div>
        </template>

        <van-popup v-model="show" round position="bottom">
            <div class="question">{{ questionDetail.index }}.{{ questionDetail.question.title }}</div>
            <div
                class="option"
                v-for="item in questionDetail.question.answers"
                :key="item.id"
                :class="{
                    correct: item.is_correct,
                    wrong: !item.is_correct && questionDetail.answer.option_no === item.option_no,
                }"
            >
                {{ item.option_no }}. {{ item.content }}
                <van-icon v-if="item.is_correct" name="success" />
                <van-icon v-if="!item.is_correct && questionDetail.answer.option_no === item.option_no" name="cross" />
            </div>
        </van-popup>
    </div>
</template>

<script>
import UserPaperResult from './UserPaperResult'
import MiddleLoading from '@/components/MiddleLoading'
import { secondsToHms } from '@/utils/util'
import { getUserPaperDetail } from '@/api/paper_period'

export default {
    name: 'UserPaperDetail',
    components: { MiddleLoading, UserPaperResult },
    data() {
        return {
            loading: true,
            show: false,
            userPaperDetail: {
                paper_period: {},
            },
            questionList: [],
            questionDetail: {
                question: {},
            },
        }
    },
    created() {
        getUserPaperDetail(this.$route.query.id).then((res) => {
            this.userPaperDetail = res.data
            this.questionList = res.data.subjects
            this.loading = false
        })
    },
    methods: {
        secondsToHms,
        showPopup(id, index) {
            this.show = true
            this.questionDetail = this.questionList.filter((item) => item.id === id)[0]
            this.questionDetail.index = index
        },
        back() {
            if (this.$store.getters.routerMarkPaper) {
                this.$router.push('/paper_period')
                this.$store.commit('paper_period/setRouterMark', false)
            } else {
                this.$router.go(-1)
            }
        },
    },
}
</script>

<style lang="less" scoped>
.user-paper-result {
    margin: 15px;

    /deep/ .title {
        position: relative;

        &::before {
            content: '';
            position: absolute;
            bottom: -5px;
            left: 0;
            width: 100%;
            height: 20%;
            background-color: @blue;
        }
    }
}

.paper-card {
    height: calc(100vh - 325px);
    background: @white;
    padding: 15px;
    margin: 15px;
    border-radius: @large-border-radius;

    .card-title {
        display: flex;
        justify-content: space-between;
        padding-bottom: 5px;

        .title {
            font-size: @large-font-size;
            font-weight: 500;
            position: relative;

            &::before {
                content: '';
                position: absolute;
                bottom: -5px;
                left: 0;
                width: 100%;
                height: 20%;
                background: @blue;
            }
        }

        .current,
        .wrong {
            position: relative;
            margin-left: 30px;
            color: @grey;
            font-size: @small-font-size;

            &::before {
                content: '';
                position: absolute;
                left: -15px;
                top: 50%;
                transform: translateY(-50%);
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background: @green;
            }
        }

        .wrong {
            &::before {
                background: @red;
            }
        }
    }

    .card-content {
        height: 80%;
        overflow-y: scroll;
        padding: 20px 15px;
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        grid-gap: 20px;
        justify-content: center;
        text-align: center;

        .item {
            width: 100%;
            aspect-ratio: 1/1;
            color: @white;
            border-radius: @medium-border-radius;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .green {
            background-color: @green;
        }

        .red {
            background-color: @red;
        }
    }
}

/deep/ .van-popup {
    padding: 20px;
    box-sizing: border-box;

    .question {
        font-size: @large-font-size;
        margin-bottom: 15px;
    }

    .option {
        padding: 15px;
        border-radius: @medium-border-radius;
        background: @bg;
        margin-bottom: 15px;
        display: flex;
        justify-content: space-between;
    }

    .correct {
        background: #dcf5e9 !important;
        color: @green;
    }

    .wrong {
        background: #fff1f0 !important;
        color: @red;
    }
}

.btn {
    background: @white;
    padding: 15px;

    .van-button {
        width: 100%;
    }
}
</style>
